import React, { useEffect, useState } from "react";
import ChatSvg from "../../../assets/svgs/Chat";
import InfoSvg from "../../../assets/svgs/InfoSvg";
import LocationSvg from "../../../assets/svgs/LocationSvg";
import UserSvg from "../../../assets/svgs/user";
import HealthSvg from "../../../assets/svgs/HealthSvg";
import CalendarCheckSvg from "../../../assets/svgs/CalendarCheckSvg";
import CloseSvg from "../../../assets/svgs/CloseSvg";
import classNames from "classnames";
import { useLSStore } from "../../../context/ls-store";
import { status } from "../data";
import Lock from "../../../assets/svgs/Lock";
import Unlock from "../../../assets/svgs/Unlock";
import CheckSvg from "../../../assets/svgs/CheckSvg";
import moment from "moment";
import {
  useCancelAppointmentMutation,
  useCreateAppointmentNoteMutation,
  useDeleteAppointmentNoteMutation,
  useEditAppointmentNoteMutation,
  useGetAppointmentNotesMutation,
  useLockAppointmentMutation,
  useUpdateAppointmentStatusMutation,
} from "../../../features/appointment/appointmentApiSlice";
import { Language } from "@mui/icons-material";
import AppointmentLockModal from "./AppointmentLockModal";
import { Icon } from "@virtuslab/tetrisly-icons";
import IconComponent from "../../../components/DataTable/Icon";
import NoteDeleteModal from "./NoteDeleteModal";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/auth/authSlice";
import AppointmentStatusModal from "./AppointmentStatusModal";
import { Tooltip } from "@mui/material";
import { useUpdatePatientNotesMutation } from "../../../features/patient/patientApiSlice";
import { numberToPhone } from "../../../utilities/resuseFunctions";
import {
  ACTIVITY_STATUS,
  ACTIVITY_TYPE,
  GENDER,
} from "../../../constants/config.constants";
import { useCreateLogsMutation } from "../../../features/logs/logsApiSlice";
import Loading from "../../../components/Loading";
import VisitCancelModal from "../../../components/Modals/VisitCancelModal";

const AppointmentSelectModal = ({
  selectedProvider,
  setRecallSchedule,
  allow,
  onClose,
}) => {
  const selectedAppointment = useLSStore((state) => state.selectedAppointment);
  const setSelectedAppointment = useLSStore(
    (state) => state.setSelectedAppointment
  );
  const user = useSelector(selectUser);

  const [cancelAppointment, { isLoading: cancelLoading }] =
    useCancelAppointmentMutation();
  const [lockAppointment, { isLoading: lockLoading }] =
    useLockAppointmentMutation();
  const [getAppointmentNotes, { isLoading: noteLoading }] =
    useGetAppointmentNotesMutation();
  const [createAppointmentNote, { isLoading: createNoteLoading }] =
    useCreateAppointmentNoteMutation();
  const [editAppointmentNote, { isLoading: noteUpdateLoading }] =
    useEditAppointmentNoteMutation();
  const [deleteAppointmentNote, { isLoading: deleteNoteLoading }] =
    useDeleteAppointmentNoteMutation();
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openLockModal, setOpenLockModal] = useState(false);
  const [appointmentNotes, setAppointmentNotes] = useState([]);
  const [addNote, setAddNote] = useState(false);
  const [note, setNote] = useState("");
  const [isPatientNote, setIsPatientNote] = useState(false);
  const [patientNote, setPatientNote] = useState("");
  const [id, setId] = useState(null);
  const [isDelete, setIsDelete] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [appointmentToChangeStatus, setAppointmentToChangeStatus] =
    useState(null);
  const [updateAppointmentStatus, { isLoading: updateStatusLoading }] =
    useUpdateAppointmentStatusMutation();
  const [updatePatientNotes, { isLoading: updateNoteLoading }] =
    useUpdatePatientNotesMutation();
  const [createLog] = useCreateLogsMutation();

  const closeAppointment = () => {
    if (onClose) {
      onClose();
    } else {
      setSelectedAppointment(null);
    }
  };

  const isLoading =
    createNoteLoading ||
    noteUpdateLoading ||
    deleteNoteLoading ||
    updateStatusLoading ||
    updateNoteLoading ||
    cancelLoading ||
    lockLoading;

  const handleCancel = async ({ reason, description, reasonId }) => {
    const payload = {
      activity: `Schedule (${selectedAppointment.appointmentId}) on ${moment(
        selectedAppointment.visitDate
      ).format("MMMM DD, YYYY")} Cancelled for Provider ${
        selectedProvider.name
      } and Patient ${selectedAppointment.patient.name} by User - ${
        user?.details?.name || ""
      } with Reason ${reason}`,
      type: ACTIVITY_TYPE.APPOINTMENT_CANCELED,
      data: {
        providerId: selectedProvider.id,
        patientId: selectedAppointment?.patient?.id,
      },
    };
    try {
      const {data: appointment} = await cancelAppointment({
        appointmentId: selectedAppointment.appointmentId,
        reason,
        description,
        practiceId: user?.organisation?.practiceId,
        patientId: selectedAppointment?.patient?.idInEhr,
        publishedId: selectedAppointment.publishedId,
        patientname: selectedAppointment?.patient?.name,
        reasonId,
      }).unwrap();

      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.SUCCESS,
        data: {
          ...payload.data,
          id: appointment.id,
          timezone: appointment.timezone,
          targetId: appointment.targetId,
          timeslot: appointment.timeslot
        },
        activity: `${payload.activity} CareSMS Appt Id: ${appointment.id}, Target Id: ${appointment.targetId}, Timeslot: ${appointment.timeslot} ${appointment.timezone ?? ""}`,
      }).unwrap();

      console.log(`Appointment ${selectedAppointment.appointmentId} cancelled`);

      setRecallSchedule(true);
    } catch (error) {
      console.log(error);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
    }

    closeAppointment();
  };

  const handleLock = async () => {
    const isLocked = selectedAppointment.status === "LOCKED";
    const payload = {
      activity: `Schedule (${selectedAppointment.appointmentId}) on ${moment(
        selectedAppointment.visitDate
      ).format("MMMM DD, YYYY")} ${
        isLocked ? "unlocked" : "locked"
      } for Provider ${selectedProvider.name} and Patient ${
        selectedAppointment.patient.name
      } by User - ${user?.details?.name || ""}. CareSMS Appt Id: ${selectedAppointment.appointmentId}, Target Id: ${selectedAppointment.targetId}, Timeslot: ${selectedAppointment.timeslot}`,
      type: isLocked
        ? ACTIVITY_TYPE.VISIT_UNLOCKED
        : ACTIVITY_TYPE.VISIT_LOCKED,
        data: {
          providerId: selectedAppointment?.providerId,
          patientId: selectedAppointment?.patient?.id,
          id: selectedAppointment.appointmentId,
          targetId: selectedAppointment.targetId,
          timeslot: selectedAppointment.timeslot,
        },
    };
    try {
      await lockAppointment({
        appointmentId: selectedAppointment.appointmentId,
      }).unwrap();
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();

      console.log(`Appointment ${selectedAppointment.appointmentId} locked`);

      setRecallSchedule(true);

      closeAppointment();
    } catch (error) {
      console.log(error);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
    }
  };

  const handleChangeStatus = async (status) => {
    const payload = {
      activity: `Schedule (${
        appointmentToChangeStatus.appointmentId
      }) on ${moment(appointmentToChangeStatus?.visitDate).format(
        "MMMM DD, YYYY"
      )} changed status to ${status} for Provider ${
        selectedProvider.name
      } and Patient ${appointmentToChangeStatus.patient.name} by User - ${
        user?.details?.name || ""
      }. CareSMS Appt Id: ${selectedAppointment.appointmentId}, Target Id: ${selectedAppointment.targetId}, Timeslot: ${selectedAppointment.timeslot}`,
      type: ACTIVITY_TYPE.VISIT_STATUS_CHANGE,
      data: {
        providerId: selectedAppointment?.providerId,
        patientId: selectedAppointment?.patient?.id,
        id: selectedAppointment.appointmentId,
        targetId: selectedAppointment.targetId,
        timeslot: selectedAppointment.timeslot,
      },
    };
    try {
      await updateAppointmentStatus({
        appointmentId: selectedAppointment.appointmentId,
        status,
      }).unwrap();

      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();

      console.log(
        `Appointment ${selectedAppointment.appointmentId} status changed to ${status}`
      );

      setRecallSchedule(true);

      closeAppointment();
    } catch (error) {
      console.log(error);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
    }
  };

  const fetchAppointmentNotes = async () => {
    try {
      const { data } = await getAppointmentNotes({
        appointmentId: selectedAppointment.appointmentId,
      }).unwrap();

      setAppointmentNotes(data);
    } catch (error) {
      console.log(error, selectedAppointment);
    }
  };

  useEffect(() => {
    fetchAppointmentNotes();
  }, []);

  const handleCancelModal = () => {
    setOpenCancelModal(!openCancelModal);
  };

  const handleLockModal = () => {
    setOpenLockModal(!openLockModal);
  };

  const handleStatusModal = (status) => {
    if (openLockModal) setAppointmentToChangeStatus(null);
    setOpenStatusModal(!openStatusModal);
  };

  const handleAddNote = () => {
    setAddNote(!addNote);
    if (addNote) {
      setNote("");
      setId(null);
    }
  };

  const handleNote = () => {
    setIsPatientNote(!isPatientNote);
    if (isPatientNote) {
      setPatientNote("");
    }
  };

  const onEdit = (note) => {
    setAddNote(!addNote);
    setId(note.id);
    setNote(note.description);
  };

  const onDelete = (note) => {
    if (isDelete) {
      setIsDelete(false);
      setId(null);
    } else {
      setIsDelete(true);
      setId(note.id);
    }
  };

  const handleSaveNote = async () => {
    const payload = {
      activity: `Appointment note added for appointmentId: ${
        selectedAppointment.appointmentId
      }, publishedId: ${selectedAppointment.publishedId} by User - ${
        user?.details?.name || ""
      }. CareSMS Appt Id: ${selectedAppointment.appointmentId}, Target Id: ${selectedAppointment.targetId}, Timeslot: ${selectedAppointment.timeslot}`,
      type: ACTIVITY_TYPE.APPOINTMENT_NOTE_ADD,
      data: {
        providerId: selectedAppointment?.providerId,
        patientId: selectedAppointment?.patient?.id,
        id: selectedAppointment.appointmentId,
        targetId: selectedAppointment.targetId,
        timeslot: selectedAppointment.timeslot,
      },
    };
    try {
      const { data } = await createAppointmentNote({
        appointmentId: selectedAppointment.appointmentId,
        description: note,
        publishedId: selectedAppointment.publishedId,
        practiceId: user?.organisation?.practiceId,
      }).unwrap();

      handleAddNote();

      setAppointmentNotes((prev) => [...prev, data]);
      setRecallSchedule(true);
      await createLog({ ...payload, status: ACTIVITY_STATUS.SUCCESS }).unwrap();
    } catch (error) {
      console.log(error, selectedAppointment);
      await createLog({ ...payload, status: ACTIVITY_STATUS.FAILED }).unwrap();
    }
  };

  const handleUpdateNote = async () => {
    const noteData = appointmentNotes.find((note) => note.id === id);
    const payload = {
      activity: `Appointment note updated for appointmentId: ${
        selectedAppointment.appointmentId
      }, publishedId: ${selectedAppointment.publishedId}, publishedNoteId: ${
        noteData.note_id
      } by User - ${user?.details?.name || ""}. CareSMS Appt Id: ${selectedAppointment.appointmentId}, Target Id: ${selectedAppointment.targetId}, Timeslot: ${selectedAppointment.timeslot}`,
      type: ACTIVITY_TYPE.APPOINTMENT_NOTE_UPDATE,
      data: {
        providerId: selectedAppointment?.providerId,
        patientId: selectedAppointment?.patient?.id,
        id: selectedAppointment.appointmentId,
        targetId: selectedAppointment.targetId,
        timeslot: selectedAppointment.timeslot,
      },
    };
    try {
      const { data } = await editAppointmentNote({
        noteId: id,
        description: note,
        publishedId: selectedAppointment.publishedId,
        practiceId: user?.organisation?.practiceId,
        publishedNoteId: noteData.note_id,
        appointmentId: selectedAppointment.appointmentId,
      }).unwrap();

      handleAddNote();

      setAppointmentNotes((prev) =>
        prev.map((note) => {
          if (note.id === id) {
            return data;
          }
          return note;
        })
      );
      setRecallSchedule(true);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
    } catch (error) {
      console.log(error, selectedAppointment);
      await createLog({ ...payload, status: ACTIVITY_STATUS.FAILED }).unwrap();
    }
  };

  const handleDeleteNote = async () => {
    const noteData = appointmentNotes.find((note) => note.id === id);
    const payload = {
      activity: `Appointment note deleted for appointmentId: ${
        selectedAppointment.appointmentId
      }, publishedId: ${selectedAppointment.publishedId}, publishedNoteId: ${
        noteData.note_id
      } by User - ${user?.details?.name || ""}. CareSMS Appt Id: ${selectedAppointment.appointmentId}, Target Id: ${selectedAppointment.targetId}, Timeslot: ${selectedAppointment.timeslot}`,
      type: ACTIVITY_TYPE.APPOINTMENT_NOTE_DELETE,
      data: {
        providerId: selectedAppointment?.providerId,
        patientId: selectedAppointment?.patient?.id,
        id: selectedAppointment.appointmentId,
        targetId: selectedAppointment.targetId,
        timeslot: selectedAppointment.timeslot,
      },
    };
    try {
      const { data } = await deleteAppointmentNote({
        noteId: id,
        publishedId: selectedAppointment.publishedId,
        practiceId: user?.organisation?.practiceId,
        publishedNoteId: noteData.note_id,
      }).unwrap();

      handleAddNote();

      setAppointmentNotes((prev) => prev.filter((note) => note.id !== id));

      setRecallSchedule(true);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
    } catch (error) {
      console.log(error, selectedAppointment);
      await createLog({ ...payload, status: ACTIVITY_STATUS.FAILED }).unwrap();
    }
  };

  const handleSavePatientNote = async () => {
    const payload = {
      activity: `Patient note updated for patient: ${
        selectedAppointment.patient?.name
      }, publishedId: ${selectedAppointment.publishedId} by User - ${
        user?.details?.name || ""
      }. CareSMS Appt Id: ${selectedAppointment.appointmentId}, Target Id: ${selectedAppointment.targetId}, Timeslot: ${selectedAppointment.timeslot}`,
      type: ACTIVITY_TYPE.APPOINTMENT_NOTE_ADD,
      data: {
        providerId: selectedAppointment?.providerId,
        patientId: selectedAppointment?.patient?.id,
        id: selectedAppointment.appointmentId,
        targetId: selectedAppointment.targetId,
        timeslot: selectedAppointment.timeslot,
      },
    };
    try {
      const { data } = await updatePatientNotes({
        patientId: selectedAppointment?.patient.id,
        notes: patientNote,
      }).unwrap();
      handleNote();

      setSelectedAppointment({
        ...selectedAppointment,
        patient: {
          ...selectedAppointment.patient,
          notes: patientNote,
        },
      });
      setRecallSchedule(true);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
    } catch (error) {
      console.log(error, selectedAppointment);
      await createLog({ ...payload, status: ACTIVITY_STATUS.FAILED }).unwrap();
    }
  };

  return (
    <>
      <Loading loading={isLoading} />
      <div
        className={classNames(
          "absolute right-0 w-96 bg-white border-t border-b border-l opacity-100 transition-all top-[0px] border-secondarygrayborder",
          selectedAppointment ? "right-0" : "right-[-400px]"
        )}
      >
        <div className="flex flex-row justify-between items-center p-4 w-full">
          <p className="m-0 text-2xl font-bold text-primaryblack">
            Appointment Details
          </p>
          <Tooltip title="Close">
            <button
              onClick={() => {
                closeAppointment();
              }}
              className="flex justify-center items-center w-10 rounded-full aspect-square bg-primarylightgrey"
            >
              <CloseSvg color={"#3062D4"} />
            </button>
          </Tooltip>
        </div>
        <div className="w-full border border-primarygrayborder" />
        <div className="h-[calc(100vh-180px)] overflow-y-auto">
          <div className="flex flex-col gap-12 p-4 w-full">
            <div className="flex flex-row gap-4 justify-start items-center">
              <CalendarCheckSvg color={"#3062D4"} />
              {selectedAppointment !== null ? (
                <p className="m-0 text-base text-primaryblack w-fit">
                  Scheduled on{" "}
                  {moment(selectedAppointment.visitDate).format("ll")}
                  <p className="m-0 text-base text-primarytextgrey w-fit">
                    {selectedAppointment.timeslot}
                  </p>
                </p>
              ) : (
                <div className="overflow-hidden relative w-64 h-6 rounded-md border animate-pulse border-primarylightgrey bg-primarylightgrey">
                  <div className="absolute top-0 left-0 w-8 h-full bg-gray-200 pulse" />
                </div>
              )}
            </div>
            <div className="flex flex-row gap-4 justify-start items-center">
              <LocationSvg color={"#3062D4"} />
              <div className="flex flex-col w-fit">
                {selectedAppointment !== null ? (
                  <>
                    <p className="m-0 text-base text-primaryblack w-fit">
                      {selectedAppointment.location.name}
                    </p>
                    <p className="m-0 text-base text-primarytextgrey w-fit">
                      {selectedAppointment.location.address}
                    </p>
                    <p className="m-0 text-base text-primarytextgrey w-fit">
                      {`${
                        selectedAppointment.patient?.poc?.phone
                          ? "phone: " +
                            numberToPhone(
                              selectedAppointment.patient?.poc?.phone
                            )
                          : ""
                      }`}
                    </p>
                  </>
                ) : (
                  <>
                    <div className="overflow-hidden relative mb-1 w-52 h-6 rounded-md border animate-pulse border-primarylightgrey bg-primarylightgrey">
                      <div className="absolute top-0 left-0 w-8 h-full bg-gray-200 pulse" />
                    </div>
                    <div className="overflow-hidden relative w-72 h-6 rounded-md border animate-pulse border-primarylightgrey bg-primarylightgrey">
                      <div className="absolute top-0 left-0 w-8 h-full bg-gray-200 pulse" />
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="flex flex-row gap-4 justify-start items-center">
              <UserSvg color={"#3062D4"} />
              <div className="flex flex-col w-fit">
                {selectedAppointment !== null ? (
                  <>
                    <p className="m-0 text-base text-primaryblack w-fit">
                      {selectedAppointment.patient.name} | ID{" "}
                      {selectedAppointment.patient.idInEhr}
                    </p>
                    <p className="m-0 text-base text-primarytextgrey w-fit">
                      Last seen:{" "}
                      {selectedAppointment.lastSeenOn}
                    </p>
                    <p className="m-0 text-base text-primarytextgrey w-fit">
                      Last seen by:{" "}
                      {selectedAppointment.lastSeenBy ?? "NA"}
                    </p>
                    <p className="m-0 text-base text-primarytextgrey w-fit">
                      Next scheduled on:{" "}
                      {selectedAppointment.nextScheduledOn}
                    </p>
                    <p className="m-0 text-base text-primarytextgrey w-fit">
                      Next scheduled with:{" "}
                      {selectedAppointment.nextScheduledWith ?? "NA"}
                    </p>
                    <p className="m-0 text-base text-primarytextgrey w-fit">
                      Next visit status:{" "}
                      {selectedAppointment.nextVisitStatus
                        ? selectedAppointment.nextVisitStatus
                            .split(/[\s_]+/)
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase()
                            )
                            .join(" ")
                        : "NA"}
                    </p>
                  </>
                ) : (
                  <>
                    <div className="overflow-hidden relative mb-1 w-44 h-6 rounded-md border animate-pulse border-primarylightgrey bg-primarylightgrey">
                      <div className="absolute top-0 left-0 w-8 h-full bg-gray-200 pulse" />
                    </div>
                    <div className="overflow-hidden relative w-52 h-6 rounded-md border animate-pulse border-primarylightgrey bg-primarylightgrey">
                      <div className="absolute top-0 left-0 w-8 h-full bg-gray-200 pulse" />
                    </div>
                  </>
                )}
              </div>
            </div>
            {selectedAppointment?.patient?.languagePreference && (
              <div className="flex flex-row gap-4 justify-start items-center">
                <Language
                  style={{
                    color: "#3062D4",
                  }}
                />
                <div className="flex flex-col w-fit">
                  <p className="m-0 text-base text-primaryblack w-fit">
                    {selectedAppointment.patient?.languagePreference ?? "NA"}
                  </p>
                </div>
              </div>
            )}
            {selectedAppointment?.patient?.genderPreference && (
              <div className="flex flex-row gap-4 justify-start items-center">
                <UserSvg color={"#3062D4"} />
                <div className="flex flex-col w-fit">
                  <p className="m-0 text-base text-primaryblack w-fit">
                    {GENDER[selectedAppointment.patient?.genderPreference] ??
                      "NA"}
                  </p>
                </div>
              </div>
            )}
            <div className="flex flex-row gap-4 justify-start items-center">
              <HealthSvg color={"#3062D4"} />
              <div className="flex flex-col w-fit">
                {selectedProvider !== null ? (
                  <>
                    <p className="m-0 text-base text-primaryblack w-fit">
                      {selectedProvider.name}
                    </p>
                    <p className="m-0 text-base text-primarytextgrey w-fit">
                      {selectedProvider.speciality}
                    </p>
                  </>
                ) : (
                  <>
                    <div className="overflow-hidden relative mb-1 w-36 h-6 rounded-md border animate-pulse border-primarylightgrey bg-primarylightgrey">
                      <div className="absolute top-0 left-0 w-8 h-full bg-gray-200 pulse" />
                    </div>
                    <div className="overflow-hidden relative w-28 h-6 rounded-md border animate-pulse border-primarylightgrey bg-primarylightgrey">
                      <div className="absolute top-0 left-0 w-8 h-full bg-gray-200 pulse" />
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="flex flex-row gap-4 justify-start items-center">
              <InfoSvg color={"#3062D4"} />
              {selectedAppointment !== null ? (
                <p className="m-0 text-base text-primaryblack w-fit">
                  {selectedAppointment.appointmentType.name}
                </p>
              ) : (
                <div className="overflow-hidden relative mb-1 w-36 h-6 rounded-md border animate-pulse border-primarylightgrey bg-primarylightgrey">
                  <div className="absolute top-0 left-0 w-8 h-full bg-gray-200 pulse" />
                </div>
              )}
            </div>
          </div>
          <div className="w-full border border-primarygrayborder" />
         {allow.view_patient_note && <div className="flex flex-col gap-2 p-4 w-full">
            <div className="flex justify-between">
              <div className="flex flex-row gap-4 justify-start items-center">
                <ChatSvg color={"#3062D4"} />
                <p className="m-0 text-base font-bold text-primaryblack w-fit">
                  Patient Notes
                </p>
              </div>
              {!selectedAppointment?.patient?.notes && allow.create_patient_note ? (
                <Tooltip title="Add patient note">
                  <button onClick={handleNote}>
                    <Icon name="20-plus" />
                  </button>
                </Tooltip>
              ) : (
                allow.update_patient_note && <Tooltip title="Edit note">
                  <button>
                    <IconComponent
                      icon={"Edit_Icon"}
                      i={selectedAppointment?.patient}
                      onClick={() => {
                        handleNote();
                        setPatientNote(selectedAppointment?.patient?.notes);
                      }}
                    />
                  </button>
                </Tooltip>
              )}
            </div>
            {isPatientNote ? (
              <div>
                <textarea
                  rows={3}
                  placeholder="Add patient note..."
                  className="px-4 py-2 w-full rounded-md border-1 placeholder:text-primarytextgrey border-primarygrayborder"
                  value={patientNote}
                  onChange={(e) => setPatientNote(e.target.value)}
                />
                <div className="flex gap-2 justify-end py-2">
                  <button
                    className="p-1 font-semibold rounded-md border border-black"
                    onClick={handleNote}
                  >
                    Cancel
                  </button>
                  <Tooltip title={!patientNote ? "Please enter the note" : ""}>
                    <button
                      disabled={!patientNote}
                      className="p-1 px-2 font-semibold text-white rounded-md bg-primaryblue"
                      onClick={handleSavePatientNote}
                    >
                      Save
                    </button>
                  </Tooltip>
                </div>
              </div>
            ) : (
              <span className="text-base">
                {selectedAppointment?.patient?.notes}
              </span>
            )}
          </div>}
          {allow.view_appointment_note && <div className="flex flex-col gap-6 p-4 w-full">
            <div className="flex justify-between">
              <div className="flex flex-row gap-4 justify-start items-center">
                <ChatSvg color={"#3062D4"} />
                <p className="m-0 text-base font-bold text-primaryblack w-fit">
                  Appointment Notes
                </p>
              </div>
              {allow.create_appointment_note && <Tooltip title="Add note">
                <button onClick={handleAddNote}>
                  <Icon name="20-plus" />
                </button>
              </Tooltip>}
            </div>
            {noteLoading ? (
              <div className="overflow-hidden relative mb-1 w-full h-16 rounded-md border animate-pulse border-primarylightgrey bg-primarylightgrey">
                <div className="absolute top-0 left-0 w-8 h-full bg-gray-200 pulse" />
              </div>
            ) : (
              appointmentNotes?.map((note) => {
                const { firstname, lastname } =
                  note?.creator?.back_office_staff || {};
                return (
                  <div className="flex flex-col w-full" key={note}>
                    <div className="flex flex-col m-0">
                      <div className="flex justify-between">
                        <span className="text-base font-bold">
                          {firstname != null
                            ? `${firstname} ${lastname}`
                            : note?.created_by === user.id
                            ? user?.details?.name
                            : "NA"}
                        </span>{" "}
                        <div className="flex gap-3 items-center">
                         {allow.update_appointment_note && <Tooltip title="Edit note">
                            <button>
                              <IconComponent
                                icon={"Edit_Icon"}
                                i={note}
                                onClick={() => onEdit(note)}
                              />
                            </button>
                          </Tooltip>}
                          {allow.delete_appointment_note && <Tooltip title="Delete note">
                            <button>
                              <IconComponent
                                icon={"Delete_Icon"}
                                i={note}
                                onClick={() => onDelete(note)}
                              />
                            </button>
                          </Tooltip>}
                        </div>
                      </div>
                      <span className="text-base">{note.description}</span>
                    </div>
                    <p className="m-0 text-xs italic text-primarytextgrey">
                      {moment(note.createdAt).format("hh:mm a MM/DD/YY")}
                    </p>
                  </div>
                );
              })
            )}
            {addNote && (
              <div>
                <textarea
                  rows={3}
                  placeholder="Add a note for this appointment..."
                  className="px-4 py-2 w-full rounded-md border-1 placeholder:text-primarytextgrey border-primarygrayborder"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
                <div className="flex gap-2 justify-end py-2">
                  <button
                    className="p-1 font-semibold rounded-md border border-black"
                    onClick={handleAddNote}
                  >
                    Cancel
                  </button>
                  <Tooltip title={!note ? "Please enter the note" : ""}>
                    <button
                      disabled={!note}
                      className="p-1 px-2 font-semibold text-white rounded-md bg-primaryblue"
                      onClick={id ? handleUpdateNote : handleSaveNote}
                    >
                      {id ? "Save" : "Add"}
                    </button>
                  </Tooltip>
                </div>
              </div>
            )}
          </div>}
          <div className="w-full border border-primarygrayborder" />
          <div className="flex flex-col gap-4 p-4 mb-4 w-full">
            <div className="w-full">
              {selectedAppointment !== null ? (
                <button
                  // disabled={["COMPLETED", "CANCELLED"].includes(
                  //   selectedAppointment.visitStatus
                  // )}
                  className={classNames(
                    "flex flex-row items-center justify-center w-full gap-2 px-3 py-2 rounded-md shadow-sm font-semibold",
                    selectedAppointment.visitStatus === "COMPLETED"
                      ? "text-primarygreen border-[1px] border-primarygreen"
                      : selectedAppointment.visitStatus === "SCHEDULED"
                      ? "text-primaryyellow border-[1px] border-primaryyellow"
                      : selectedAppointment.visitStatus === "CANCELLED"
                      ? "text-primaryred border-[1px] border-primaryred"
                      : selectedAppointment.visitStatus === "NOSHOW"
                      ? "text-primaryorange border-[1px] border-primaryorange"
                      : "text-primaryblue border-[1px] border-primaryblue"
                  )}
                  onClick={() => {
                    setAppointmentToChangeStatus(selectedAppointment);
                    handleStatusModal(selectedAppointment.visitStatus);
                  }}
                >
                  {selectedAppointment.visitStatus === "SCHEDULED" ? (
                    // <Unlock color={"#F2C94C"} />
                    <Icon name="20-hourglass" color={"#F2C94C"} />
                  ) : selectedAppointment.visitStatus === "CONFIRMED" ? (
                    <Icon name="20-calendar-check" color={"#3062D4"} />
                  ) : selectedAppointment.visitStatus === "CANCELLED" ? (
                    <Icon name="20-calendar-close" color={"#eb5757"} />
                  ) : selectedAppointment.visitStatus === "NOSHOW" ? (
                    <Icon name="20-user-minus" color={"#F59638"} />
                  ) : (
                    <CheckSvg color={"#27AE60"} />
                  )}
                  {selectedAppointment.visitStatus === "SCHEDULED"
                    ? "Pending"
                    : selectedAppointment.visitStatus === "NOSHOW"
                    ? "No Show"
                    : selectedAppointment.visitStatus === "CONFIRMED"
                    ? "Confirmed"
                    : selectedAppointment.visitStatus === "CANCELLED"
                    ? "Cancelled"
                    : "Completed"}
                </button>
              ) : (
                <div className="overflow-hidden relative w-full h-10 rounded-md border animate-pulse border-primarylightgrey bg-primarylightgrey">
                  <div className="absolute top-0 left-0 w-8 h-full bg-gray-200 pulse" />
                </div>
              )}
            </div>
            <div className="w-full">
              {selectedAppointment !== null ? (
                <button
                  className={classNames(
                    "flex flex-row items-center justify-center w-full gap-2 px-3 py-2 rounded-md shadow-sm",
                    selectedAppointment.status === status.published
                      ? "bg-primarygreen"
                      : selectedAppointment.status === status.unlocked
                      ? "bg-primaryyellow"
                      : "bg-primaryblue"
                  )}
                  disabled={selectedAppointment.status === status.published}
                  onClick={handleLockModal}
                >
                  {selectedAppointment.status === status.published ? (
                    <div className="w-[18px] h-[18px] bg-white rounded-full">
                      <CheckSvg color={"#6FCF97"} />
                    </div>
                  ) : selectedAppointment.status === status.unlocked ? (
                    <Unlock color={"#FFF"} />
                  ) : (
                    <Lock color={"#FFF"} />
                  )}
                  <p className="m-0 text-base font-semibold text-white">
                    {selectedAppointment.status === status.published
                      ? "Published"
                      : selectedAppointment.status === status.unlocked
                      ? "Unlocked"
                      : "Locked"}
                  </p>
                </button>
              ) : (
                <div className="overflow-hidden relative w-full h-10 rounded-md border animate-pulse border-primarylightgrey bg-primarylightgrey">
                  <div className="absolute top-0 left-0 w-8 h-full bg-gray-200 pulse" />
                </div>
              )}
            </div>
            {!["COMPLETED", "CANCELLED"].includes(
              selectedAppointment.visitStatus
            ) && (
              <div className="w-full">
                <button
                  onClick={handleCancelModal}
                  className="flex flex-row justify-center items-center px-3 py-2 w-full rounded-md border shadow-sm border-primarygrayborder"
                >
                  <p className="m-0 text-base font-semibold text-primaryred">
                    Cancel Appointment
                  </p>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <NoteDeleteModal
        open={isDelete}
        handleCancelModal={onDelete}
        handleCancel={handleDeleteNote}
      />
      {openCancelModal && (
        <VisitCancelModal
          open={openCancelModal}
          handleClose={handleCancelModal}
          handleCancel={handleCancel}
          selectedVisit={selectedAppointment}
        />
      )}
      <AppointmentLockModal
        open={openLockModal}
        handleLockModal={handleLockModal}
        handleLock={handleLock}
        status={selectedAppointment?.status}
      />
      {appointmentToChangeStatus && (
        <AppointmentStatusModal
          open={openStatusModal}
          handleCancel={handleStatusModal}
          handleSubmit={handleChangeStatus}
          status={appointmentToChangeStatus?.visitStatus}
        />
      )}
    </>
  );
};

export default AppointmentSelectModal;